<template>
  <div class="business-attributes-widget-page">
    <div class="dark-preview">
      <BusinessAttributesWidget
        :data="mockData"
        :is-owner="isOwner"
      />
    </div>

    <div class="floating-controls">
      <label>
        <input
          v-model="isOwner"
          type="checkbox"
        > Is Owner
      </label>
      <label>
        Entity
        <select v-model="mockData.entity">
          <option :value="null">— none —</option>
          <option value="LLC">LLC</option>
          <option value="Corporation">Corporation</option>
          <option value="Sole Proprietor">Sole Proprietor</option>
        </select>
      </label>
      <label>
        Years in business
        <select v-model.number="mockData.yearsInBusiness">
          <option :value="null">— none —</option>
          <option
            v-for="n in 30"
            :key="n"
            :value="n"
          >{{ n }}</option>
        </select>
      </label>
      <label>
        Company size
        <select v-model="mockData.companySize">
          <option :value="null">— none —</option>
          <option value="1">1</option>
          <option value="2-10">2-10</option>
          <option value="11-50">11-50</option>
          <option value="51-200">51-200</option>
        </select>
      </label>
      <label>
        Annual revenue
        <select v-model="mockData.annualRevenue">
          <option :value="null">— none —</option>
          <option value="$1,350,000">$1,350,000</option>
          <option value="$500,000">$500,000</option>
          <option value="$1,000,000">$1,000,000</option>
        </select>
      </label>
    </div>
  </div>
</template>

<script>
import BusinessAttributesWidget from '@/components/widget/businessAttributes/index.vue'

export default {
  name: 'BusinessAttributesWidgetPage',
  components: {
    BusinessAttributesWidget,
  },
  data() {
    return {
      isOwner: true,
      mockData: {
        entity: 'LLC',
        yearsInBusiness: 7,
        companySize: '2-10',
        annualRevenue: '$1,350,000',
      },
    }
  },
}
</script>

<style scoped lang="scss">
.business-attributes-widget-page {
  @include stack-space($space-large);
  @include inset-space($space-large);
  background-color: $color-background-primary;

  .dark-preview {
    background-color: $color-black;
    border-radius: $radius-large;
    padding: $space-large;
  }

  .floating-controls {
    position: fixed;
    top: $space-medium;
    right: $space-medium;
    background: rgba($color-white, 0.95);
    border: 1px solid $color-neutral-light;
    border-radius: $radius-medium;
    padding: $space-medium;
    z-index: $z-index-dialog;
    box-shadow: 0 2px 8px rgba($color-black, 0.1);
    display: flex;
    flex-direction: column;
    gap: $space-small;

    label {
      font-weight: bold;
      font-size: 0.875rem;
      display: flex;
      flex-direction: column;
      gap: $space-xsmall;
    }

    select {
      padding: $space-xsmall;
      font-size: 0.875rem;
    }
  }
}
</style>